import { setUserAboutData } from '@/store';
import { api } from '../core';
import { USER_ABOUT_TAG } from '../constants';

export const UserRoleType = {
  NURSE: 'NURSE',
  MANAGER: 'MANAGER',
  ADMIN: 'ADMIN',
  GLOBAL_ADMIN: 'GLOBAL_ADMIN',
  MEDICAL_RECORDS_ADMIN: 'MEDICAL_RECORDS_ADMIN',
  LAWYER: 'LAWYER',
} as const;
export type UserRoleType = (typeof UserRoleType)[keyof typeof UserRoleType];

export interface UserAboutData {
  createdAt: string;
  userEmail: string;
  userFirstName: string;
  userId: string;
  userLastName: string;
  userName: string;
  userRole: UserRoleType;
  isMls: boolean;
  organisationId: string;
}
export type UserAboutResponse = UserAboutData;

type GetUserAboutProps = {
  abortController?: AbortController;
};

const getUserAboutApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUserAbout: builder.query<UserAboutResponse, GetUserAboutProps>({
      query: ({ abortController = new AbortController() }: GetUserAboutProps) => ({
        url: `user/about`,
        method: 'GET',
        signal: abortController.signal,
      }),
      providesTags: () => [{ type: USER_ABOUT_TAG }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (data) {
            dispatch(setUserAboutData(data));
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getUserAbout in onQueryStarted:', error);
          }
        }
      },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetUserAboutQuery } = getUserAboutApi;
